// Psychologist/Favorites/FavoritesContext.tsx

import React, {createContext, ReactNode, useEffect, useState} from 'react';

interface FavoritesContextType {
    favoritePsychologists: number[];
    toggleFavorite: (psychologistId: number) => void;
    isFavorite: (psychologistId: number) => boolean;
}

export const FavoritesContext = createContext<FavoritesContextType>({
    favoritePsychologists: [],
    toggleFavorite: () => {
    },
    isFavorite: () => false,
});

interface FavoritesProviderProps {
    children: ReactNode;
}

export const FavoritesProvider: React.FC<FavoritesProviderProps> = ({children}) => {
    const [favoritePsychologists, setFavoritePsychologists] = useState<number[]>([]);

    useEffect(() => {
        const favorites = JSON.parse(localStorage.getItem('favorite_psychologists') || '[]') as number[];
        setFavoritePsychologists(favorites);
    }, []);

    const toggleFavorite = (psychologistId: number) => {
        setFavoritePsychologists((prevFavorites) => {
            let updatedFavorites;
            if (prevFavorites.includes(psychologistId)) {
                updatedFavorites = prevFavorites.filter(id => id !== psychologistId);
            } else {
                updatedFavorites = [...prevFavorites, psychologistId];
            }
            localStorage.setItem('favorite_psychologists', JSON.stringify(updatedFavorites));
            return updatedFavorites;
        });
    };

    const isFavorite = (psychologistId: number) => {
        return favoritePsychologists.includes(psychologistId);
    };

    return (
        <FavoritesContext.Provider value={{favoritePsychologists, toggleFavorite, isFavorite}}>
            {children}
        </FavoritesContext.Provider>
    );
};
